import axios from 'axios'
import {actionTypes} from '@/commons/constants'

export default {
    async [actionTypes.CUPOM.VALIDAR]({state}, body) {
        const {data} = await axios.post('api/cupom/validar', body)
        return data
    },
}